import type { ReactElement } from 'react';
import { useAuth } from '@fetmode/app-core';
import { t } from '@fetmode/i18n';
import { Navigate } from 'react-router-dom';

import { useStudioModel } from '../studio/index.js';
import { StudioRecruitPage } from './StudioRecruitPage.js';
import './studio-recruit.css';

export function StudioHomePage(): ReactElement {
  const { user, isLoading: authLoading } = useAuth();
  const { profile, isLoading: modelLoading } = useStudioModel();

  if (authLoading || (Boolean(user) && modelLoading)) {
    return <p className="studio-recruit__loading">{t('common.studio.dashboard.loading')}</p>;
  }

  if (user && profile?.canBroadcast) {
    return <Navigate to="/settings/overview" replace />;
  }

  if (user && !profile?.canBroadcast) {
    return <Navigate to="/onboarding" replace />;
  }

  return <StudioRecruitPage />;
}
